import React from 'react'

const Download = () => {
    return (
        <>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 place-items-center h-[calc(100vh-200px)]">
            <div>
                    <img src="/assets/images/download.jpg" alt="download" className='max-w-full p-7' />
                </div>
                <div className='md:px-7 px-4 flex flex-col justify-evenly'>
                    <h1 className='md:text-3xl text-xl mb-2 font-bold'>Metatrader 5 For Mobile And Desktop</h1>
                    <p className='my-2 mb-5'>Download Metatrader 5 for mobile and desktop on your smartphone or tablet. Metatrader 5 is a powerful trading platform that allows you to trade stocks, futures, and options. With its intuitive interface, advanced features, and support for multiple currencies, Metatrader 5 is a popular choice for beginners and professionals.</p>
                    <p className='my-2 text-lg'>Available for Android, IOS and Windows</p>
                    <div className="flex">
                        <a href='https://download.mql5.com/cdn/mobile/mt5/android?server=HorizonFXTradings-Server' target='_blank' >
                            <img src="/assets/images/ios.png" alt="ios" className='h-9 mx-3 ms-0' />
                        </a>
                        <a href='https://download.mql5.com/cdn/mobile/mt5/ios?server=HorizonFXTradings-Server' target='_blank'>
                            <img src="/assets/images/android.png" alt="android" className='h-9 mx-3' />
                        </a>
                        <a href='https://download.mql5.com/cdn/web/horizon.fx.tradings/mt5/horizonfxtradings5setup.exe' target='_blank'>
                            <img src="/assets/images/windows.png" alt="windows" className='h-9 mx-3' />
                        </a>
                        <a href='https://download.mql5.com/cdn/web/metaquotes.ltd/mt5/MetaTrader5.pkg.zip' target='_blank'>
                            <img src="/assets/images/mac.png" alt="android" className='h-9 mx-3' />
                        </a>
                    </div>
                    <a href="#" className="button"></a>
                </div>
                
            </div>
        </>
    )
}

export default Download